import Vue from "vue";
import VueRouter from "vue-router";
import errorRoutes from './routes/error';

Vue.use(VueRouter);

// 导出 routes 文件夹下的所有 *.route.js 文件路由
const modules = require.context("./routes", false, /\.route.js$/);
const exportRoutes = [];
modules.keys().forEach((key) => {
  exportRoutes.push(...modules(key).default);
});

export const routes = [...exportRoutes, ...errorRoutes];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(async (to, from, next) => {
  console.log("%c beforeEach to => ", "color: #fff; background: #FDB13C;", to);
  // const title = to.meta?.title;
  // if (title) document.title = title;
  next();
});

export default router;
